(function () {
  'use strict';

  if (window.__mmMenuInitialized) return;
  window.__mmMenuInitialized = true;

  /* =========================================================
     CARROSSEL DE PRODUTOS
  ========================================================= */

  function renderCarousel(carousel, newIndex) {
    var slides = Array.prototype.slice.call(
      carousel.querySelectorAll('[data-mm-slide]')
    );
    if (!slides.length) return;

    if (newIndex < 0) newIndex = slides.length - 1;
    if (newIndex >= slides.length) newIndex = 0;

    slides.forEach(function (slide, i) {
      var isActive = i === newIndex;
      slide.classList.toggle('is-active', isActive);

      if (isActive) {
        slide.removeAttribute('hidden');
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.setAttribute('hidden', '');
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    carousel.dataset.mmCurrentSlide = String(newIndex);
  }

  function initCarousel(carousel) {
    var slides = Array.prototype.slice.call(
      carousel.querySelectorAll('[data-mm-slide]')
    );
    var prevBtn = carousel.querySelector('[data-mm-prev]');
    var nextBtn = carousel.querySelector('[data-mm-next]');

    if (!slides.length) return;

    if (slides.length <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      renderCarousel(carousel, 0);
      return;
    }

    if (prevBtn) prevBtn.style.display = '';
    if (nextBtn) nextBtn.style.display = '';

    var startIndex = slides.findIndex(function (s) {
      return s.classList.contains('is-active');
    });
    if (startIndex < 0) startIndex = 0;

    renderCarousel(carousel, startIndex);
  }

  function initAllCarousels(root) {
    (root || document)
      .querySelectorAll('[data-mm-carousel]')
      .forEach(initCarousel);
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-mm-prev], [data-mm-next]');
    if (!button) return;

    var carousel = button.closest('[data-mm-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('[data-mm-slide]');
    if (slides.length <= 1) return;

    e.preventDefault();

    var current = parseInt(carousel.dataset.mmCurrentSlide || '0', 10);
    var next = button.matches('[data-mm-next]')
      ? current + 1
      : current - 1;

    renderCarousel(carousel, next);
  });

  /* =========================================================
     POSICIONAMENTO DO PAINEL (evita estourar a tela)
  ========================================================= */

  function positionMega(item, mega) {
    // reseta antes de medir, senão a medição herda o ajuste anterior
    mega.style.left = '';

    var margin = 16; // respiro mínimo nas bordas da tela
    var itemRect = item.getBoundingClientRect();
    var megaWidth = mega.getBoundingClientRect().width;
    var viewportWidth = window.innerWidth;

    // Por padrão, o painel nasce colado na esquerda do item (left:0).
    // "naturalLeft" é onde a borda esquerda do painel cairia na tela.
    var naturalLeft = itemRect.left;
    var naturalRight = naturalLeft + megaWidth;

    var overflowRight = naturalRight - (viewportWidth - margin);

    if (overflowRight > 0) {
      var shift = overflowRight;

      // Não deixa empurrar tanto pra esquerda a ponto de
      // a borda esquerda do painel sair da tela também.
      var resultingLeft = naturalLeft - shift;
      if (resultingLeft < margin) {
        shift = naturalLeft - margin;
      }

      mega.style.left = (-shift) + 'px';
    }
  }

  /* =========================================================
     ABRIR / FECHAR SUBMENU (DESKTOP)
  ========================================================= */

  function initMenuItems(root) {
    var allItems = document.querySelectorAll('[data-mm-item]');
    var scopedItems = (root || document).querySelectorAll('[data-mm-item]');

    scopedItems.forEach(function (item) {
      if (item.__mmBound) return;
      item.__mmBound = true;

      var trigger = item.querySelector('[data-mm-trigger]');
      var mega = item.querySelector('[data-mm-mega]');
      var closeTimer;

      if (!mega || !trigger) return;

      function open() {
        clearTimeout(closeTimer);
        allItems.forEach(function (i) { i.classList.remove('mm-open'); });
        item.classList.add('mm-open');
        positionMega(item, mega);
      }

      function close() {
        item.classList.remove('mm-open');
      }

      function scheduleClose() {
        closeTimer = setTimeout(close, 150);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (item.classList.contains('mm-open')) {
            close();
          } else {
            open();
          }
        }
        if (e.key === 'Escape') {
          close();
          trigger.focus();
        }
      });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          scheduleClose();
        }
      });

      trigger.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches) {
          if (!item.classList.contains('mm-open')) {
            e.preventDefault();
            open();
          }
        }
      });
    });

    if (!window.__mmResizeBound) {
      window.__mmResizeBound = true;
      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-mm-item].mm-open').forEach(function (openItem) {
          var openMega = openItem.querySelector('[data-mm-mega]');
          if (openMega) positionMega(openItem, openMega);
        });
      });
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mm-item]')) {
      document.querySelectorAll('[data-mm-item].mm-open').forEach(function (i) {
        i.classList.remove('mm-open');
      });
    }
  });

  /* =========================================================
     GAVETA MOBILE (Categorias / Menu)
  ========================================================= */

  function initDrawer(root) {
    var scope = root || document;
    var drawer = scope.querySelector('[data-mm-drawer]');
    if (!drawer || drawer.__mmBound) return;
    drawer.__mmBound = true;

    var openBtns = document.querySelectorAll('[data-mm-drawer-open]');
    var closeEls = drawer.querySelectorAll('[data-mm-drawer-close]');
    var tabs = drawer.querySelectorAll('[data-mm-tab]');
    var panels = drawer.querySelectorAll('[data-mm-tab-panel]');

    function switchTab(target) {
      var tabBtn = drawer.querySelector('[data-mm-tab="' + target + '"]');
      if (tabBtn) tabBtn.click(); // reaproveita o listener já ligado abaixo
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer();

        var targetTab = btn.getAttribute('data-mm-open-tab');
        if (targetTab) {
          switchTab(targetTab);

          // Foca o campo de busca depois que a gaveta terminar de abrir
          if (targetTab === 'menu') {
            setTimeout(function () {
              var searchInput = drawer.querySelector('.mm-drawer__search input');
              if (searchInput) searchInput.focus();
            }, 320);
          }
        }
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-mm-tab');

        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        panels.forEach(function (panel) {
          panel.classList.toggle(
            'is-active',
            panel.getAttribute('data-mm-tab-panel') === target
          );
        });
      });
    });

    // Sanfona de categorias: clique abre/fecha, um item por vez.
    var accordions = drawer.querySelectorAll('[data-mm-accordion]');

    accordions.forEach(function (accordion) {
      var trigger = accordion.querySelector('[data-mm-accordion-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var wasOpen = accordion.classList.contains('is-open');

        accordions.forEach(function (a) { a.classList.remove('is-open'); });

        if (!wasOpen) {
          accordion.classList.add('is-open');
        }
      });
    });
  }

  /* =========================================================
     INICIALIZAÇÃO
  ========================================================= */

  function initAll(root) {
    initMenuItems(root);
    initAllCarousels(root);
    initDrawer(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('[id^="shopify-section-"]');
    initAll(section || document);
  });
})();
